import React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";

export default function PageTransition(Page: any) {
  return (props: any) => (
    <div className="page">
      <TransitionGroup>
        <CSSTransition
          key={props.location?.pathname ?? props.match?.path}
          appear={true}
          timeout={{ appear: 300, enter: 300, exit: 300 }}
          classNames="Grow"
        >
          <Page {...props} />
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
}
